import React, { useState } from 'react'
import ProfileCard from './Common/ProfileCard'
import WeeklyScheduleList from './Common/WeeklyScheduleList'
import AdditionList from './Common/AdditionList'
import ExclusiontList from './Common/ExclusiontList'
import moment from 'moment'
import firebase from 'firebase';
import CustomModal from '../CustomModal'
import AddScheduleTime from './Common/AddScheduleTime'
import AddDateRange from './Common/AddDateRange'
import AddExclusionDate from './Common/AddExclusionDate'

function ScheduleWithAdditionExclusion({ setExclusions, setAdditions, setWeeklySchedule, additions, exclusions, weeklySchedule, userInfo }) {
    const [AddTimeRangeError, setAddTimeRangeError] = useState('');
    const [additionError, setAdditionError] = useState(''); 
    const [exclusionError, setExclusionError] = useState('');
    const [currentDayIndex, setCurrentDayIndex] = useState(null);
    const [newTimeRange, setNewTimeRange] = useState({ startTime: '', endTime: '' });
    const [newAdditionRange, setNewAdditionRange] = useState([new Date(), new Date()]);
    const [newExclusionDate, setNewExclusionDate] = useState(new Date());
    const [showAddTimeModal, setShowAddTimeModal] = useState(false);
    const [showAddAdditionModal, setShowAddAdditionModal] = useState(false);
    const [showAddExclusionModal, setShowAddExclusionModal] = useState(false);

    const handleRemoveExclusion = (item) => {
        setExclusions(prev => prev.filter(e => e.id !== item.id));
      }
    
    const handleRemoveAddition = (item) => {
        setAdditions(prev => prev.filter(a => a.id !== item.id));
    }
    
    const handleRemoveSchedule = (index,timeIndex) => {
        setWeeklySchedule(prev => {
            const updated = [...prev];
            updated[index].times.splice(timeIndex, 1);
            updated[index].active = updated[index].times.length > 0;
            return updated;
        });
    }
    const handleAddTime = (index) => {
        // Get the current time in the local timezone
        const now = moment();
    
        // Round to the next 15-minute interval for startTime
        const minutes = now.minutes();
        const roundedMinutes = Math.ceil(minutes / 15) * 15; // Round up to next 15-minute interval
        const startTime = now.clone().minutes(roundedMinutes).seconds(0).milliseconds(0);
    
        // Set endTime to 15 minutes after startTime
        const endTime = startTime.clone().add(15, 'minutes');
    
        // Convert to ISO 8601 strings (local timezone)
        const formattedStartTime = startTime.toISOString(); // e.g., "2025-03-12T13:00:00Z"
        const formattedEndTime = endTime.toISOString();     // e.g., "2025-03-12T13:15:00Z"
    
        // Update the state with ISO 8601 strings
        setCurrentDayIndex(index);
        setNewTimeRange({
          startTime: formattedStartTime,
          endTime: formattedEndTime
        });
        setShowAddTimeModal(true);
      };
    
      const handleTimeRangeChange = (time) => {
        console.log('Time object received:', time);
    
        setNewTimeRange({
          startTime: time.startTime || newTimeRange.startTime,
          endTime: time.endTime || newTimeRange.endTime
        });
      };
    
      const handleSaveTime = () => {
        if (newTimeRange.startTime && newTimeRange.endTime) {
          const startMoment = moment(newTimeRange.startTime);
          const endMoment = moment(newTimeRange.endTime);
          const newTimeSlot = `${startMoment.format('h:mm A')} - ${endMoment.format('h:mm A')}`;
      
          // Extract just the time portion for comparison (ignoring date/year)
          const newStartTime = moment(startMoment.format('h:mm A'), 'h:mm A');
          const newEndTime = moment(endMoment.format('h:mm A'), 'h:mm A');
      
          // Validate against existing time ranges for the selected day
          const selectedDay = weeklySchedule[currentDayIndex];
      
          let hasOverlap = false;
          let overlapMessage = '';
      
          if (selectedDay.times.length > 0) {
            for (const timeSlot of selectedDay.times) {
              // Parse existing time slot (e.g., "1:00 PM - 2:00 PM")
              const [existingStartStr, existingEndStr] = timeSlot.split(' - ');
              const existingStartTime = moment(existingStartStr, 'h:mm A');
              const existingEndTime = moment(existingEndStr, 'h:mm A');
      
              // Check for overlap (ignoring date/year)
              const startsBeforeExistingEnd = newStartTime.isBefore(existingEndTime);
              const endsAfterExistingStart = newEndTime.isAfter(existingStartTime);
      
              if (startsBeforeExistingEnd && endsAfterExistingStart) {
                hasOverlap = true;
                overlapMessage = `The new time range (${newTimeSlot}) overlaps with an existing slot (${timeSlot}) on ${selectedDay.day}.`;
                break;
              }
            }
          }
      
          if (hasOverlap) {
            // Display an error message (using alert or a state for UI display)
            setAddTimeRangeError(overlapMessage);
            console.error(overlapMessage);
          } else {
            setAddTimeRangeError('');
            // No overlap, proceed to save the time slot
            setWeeklySchedule((prev) => {
              const updatedSchedule = [...prev];
              updatedSchedule[currentDayIndex].times.push(newTimeSlot);
              updatedSchedule[currentDayIndex].active = true;
              return updatedSchedule;
            });
            setShowAddTimeModal(false);
            setNewTimeRange({ startTime: '', endTime: '' });
          }
        }
      };
    
      const handleAddAddition = () => {
        if (newAdditionRange?.length === 2) {
          // Convert new range to timestamps for comparison (ignoring time)
          const newStartTimestamp = new Date(newAdditionRange[0].toDateString()).getTime();
          const newEndTimestamp = new Date(newAdditionRange[1].toDateString()).getTime();
    
          console.log('New Addition Range:', {
            start: newAdditionRange[0],
            end: newAdditionRange[1],
            startTimestamp: newStartTimestamp,
            endTimestamp: newEndTimestamp,
          });
    
          // Check for duplication with existing additions
          const isDuplicate = additions.some(addition => {
            const existingStartTimestamp = addition.range[0] instanceof firebase.firestore.Timestamp ? new Date(addition.range[0].toDate().toLocaleDateString()).getTime() : new Date(addition.range[0].toDateString()).getTime();
            const existingEndTimestamp = addition.range[1] instanceof firebase.firestore.Timestamp ? new Date(addition.range[1].toDate().toLocaleDateString()).getTime() : new Date(addition.range[1].toDateString()).getTime();
            console.log('Existing Addition Range:', {
              start: addition.range[0],
              end: addition.range[1],
              startTimestamp: existingStartTimestamp,
              endTimestamp: existingEndTimestamp,
            });
            return newStartTimestamp === existingStartTimestamp && newEndTimestamp === existingEndTimestamp;
          });
    
          if (isDuplicate) {
            setAdditionError('This date range already exists in additional availability.');
            console.error('Duplicate addition range detected:', newAdditionRange);
          } else {
            setAdditionError('');
            setAdditions(prev => [...prev, { 
              id: prev.length + 1, 
              range: [new Date(newAdditionRange[0]), new Date(newAdditionRange[1])] // Create new Date objects
            }]);
            setShowAddAdditionModal(false);
            setNewAdditionRange([new Date(), new Date()]);
          }
        }
      };
    
      const handleAddExclusion = () => {
        if (newExclusionDate) {
          // Convert new exclusion date to timestamp for comparison (ignoring time)
          const newExclusionTimestamp = new Date(newExclusionDate.toDateString()).getTime();
    
          console.log('New Exclusion Date:', {
            date: newExclusionDate,
            timestamp: newExclusionTimestamp,
          });
    
          // Check for duplication with existing exclusions
          const isDuplicate = exclusions.some(exclusion => {
            const existingExclusionTimestamp = exclusion.date instanceof firebase.firestore.Timestamp ? new Date(exclusion.date.toDate().toLocaleDateString()).getTime() : new Date(exclusion.date.toDateString()).getTime();
            console.log('Existing Exclusion Date:', {
              date: exclusion.date,
              timestamp: existingExclusionTimestamp,
            });
            return newExclusionTimestamp === existingExclusionTimestamp;
          });
    
          if (isDuplicate) {
            setExclusionError('This date already exists in excluded dates.');
            console.error('Duplicate exclusion date detected:', newExclusionDate);
          } else {
            setExclusionError('');
            setExclusions(prev => [...prev, { 
              id: prev.length + 1, 
              date: new Date(newExclusionDate) // Create new Date object
            }]);
            setShowAddExclusionModal(false);
            setNewExclusionDate(new Date());
          }
        }
      };
  return (
    <>
        <div className="appointment-card-body card-body d-flex justify-content-center">
            <div style={{ width: '100%'}}>
            <h3 className='section-title'>Setup Appoinment Schedule</h3>
            <p className="subtitle">
                Define weekly schedule for appoitments, specific date/times and any additions / exclusions such as annual leave or public holidays.
            </p>
            <div className='mb-3'>
                <ProfileCard userInfo={userInfo} />
            </div>
            <div className="schedule-grid">
                <WeeklyScheduleList handleAddTime={handleAddTime} handleRemoveSchedule={handleRemoveSchedule} weeklySchedule={weeklySchedule} />
                <div className="additions-exclusions">
                <h4 className="section-title">Additions and Exclusions</h4>
                <div className="button-group">
                    <button 
                    className="btn" style={{ background: '#121d55', color: 'white' }}
                    onClick={() => setShowAddAdditionModal(true)}
                    >
                    Add Addition
                    </button>
                    <button 
                    className="btn" style={{ color: '#121d55', background: 'white', border: '1px solid #121d55', borderRadius: '5px' }}
                    onClick={() => setShowAddExclusionModal(true)}
                    >
                    Add Exclusion
                    </button>
                </div>
                <div className="special-dates-list">

                    <AdditionList additions={additions} handleRemoveAddition={handleRemoveAddition} />
                    <ExclusiontList handleRemoveExclusion={handleRemoveExclusion} exclusions={exclusions} />
                    
                    {additions.length === 0 && exclusions.length === 0 && (
                    <span className="no-schedule">No Addition and Exclusion date added</span>
                    )}
                </div>
                </div>
            </div>
            </div>
        </div>
        <CustomModal show={showAddTimeModal} setShow={setShowAddTimeModal} title="Add Time Slot">
            <AddScheduleTime newTimeRange={newTimeRange} handleSaveTime={handleSaveTime} handleTimeRangeChange={handleTimeRangeChange} AddTimeRangeError={AddTimeRangeError}/>
        </CustomModal>

        <CustomModal show={showAddAdditionModal} setShow={setShowAddAdditionModal} title="Add Availability Range">
            <AddDateRange  setNewAdditionRange={setNewAdditionRange} newAdditionRange={newAdditionRange} handleAddAddition={handleAddAddition} additionError={additionError} />
        </CustomModal>

        <CustomModal show={showAddExclusionModal} setShow={setShowAddExclusionModal} title="Add Exclusion Date">
            <AddExclusionDate newExclusionDate={newExclusionDate} setNewExclusionDate={setNewExclusionDate} exclusionError={exclusionError} handleAddExclusion={handleAddExclusion} />
        </CustomModal>
    </>
  )
}

export default ScheduleWithAdditionExclusion
